// Dekoder formatu chunka v1 (backend/worldgen/codec.py).
import { CHUNK_FORMAT_VERSION, isBlocked } from './tiles.js';

export interface Chunk {
  cx: number; cy: number; size: number;
  ground: Uint8Array; road: Uint8Array; building: Uint8Array; object: Uint8Array;
  collision: Uint8Array;
}

const HEADER = 15;

async function inflate(data: Uint8Array<ArrayBuffer>): Promise<Uint8Array> {
  const stream = new Blob([data]).stream().pipeThrough(new DecompressionStream('deflate'));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

export async function decodeChunk(buf: ArrayBuffer): Promise<Chunk> {
  const v = new DataView(buf);
  const magic = String.fromCharCode(v.getUint8(0), v.getUint8(1), v.getUint8(2), v.getUint8(3));
  const version = v.getUint16(4, true);
  if (magic !== 'DLC1' || version !== CHUNK_FORMAT_VERSION) throw new Error('Nieobsługiwany format chunka');
  const cx = v.getInt32(6, true), cy = v.getInt32(10, true), size = v.getUint8(14);
  const body = await inflate(new Uint8Array(buf, HEADER) as Uint8Array<ArrayBuffer>);
  const n = size * size;
  const ground = body.slice(0, n), road = body.slice(n, 2 * n);
  const building = body.slice(2 * n, 3 * n), object = body.slice(3 * n, 4 * n);
  const collision = new Uint8Array(n);
  for (let i = 0; i < n; i++) collision[i] = isBlocked(ground[i], road[i], building[i], object[i]) ? 1 : 0;
  return { cx, cy, size, ground, road, building, object, collision };
}
